/**
 * @author lvcx
 * @description 限制字数
 */
const limitWords = (val,num) => {
  // 判断字数
  let vals = val || '';
  if (vals.length > num) {
    return vals.substring(0, num) + '...';
  } else {
    return vals
  }
};

export default limitWords;


// WEBPACK FOOTER //
// ./src/filters/limitWords/index.js